module.exports = __webpack_public_path__ + "img/mobilehardwareOpen4.1069ba2c.png";